<photo-field
  [title]="title"
  [uploader]="uploadChain.getUnit(identifier).uploader"
  [identifier]="identifier"
  [photo]="photo"
  [uploadError]="uploadChain.getUploadError(identifier)"
  (selectedFile)="onSelectFile()"
  (removeFile)="onRemoveFile()"
></photo-field>
